/**
 * The drawer's free-shipping panel opens showing its meters, then collapses.
 *
 * Closed-by-default was the wrong default. The panel answers a question the
 * shopper has not asked yet — "you are $12 from free shipping at Tealish" —
 * and a collapsed summary asks them to go looking for news they did not know
 * existed. Open-then-close shows the meters once, at the moment the drawer
 * appears, and then gives the space back to the cart list.
 *
 * It backs off whenever the shopper is actually using it: pointer over the
 * panel, focus inside it, or any toggle of their own cancels the timer for
 * good. Collapsing something out from under a hand is worse than never having
 * opened it.
 *
 * Horizon re-renders the drawer on every cart change, so each render is a fresh
 * element and runs this again — which is right. A cart change is exactly when
 * the numbers moved and are worth showing.
 */

const DEFAULT_DELAY = 4000;

function arm(panel) {
  if (panel.dataset.bbArmed) return;
  panel.dataset.bbArmed = '1';

  const delay = Number(panel.dataset.bbAutoclose) || DEFAULT_DELAY;
  let timer = null;

  const cancel = () => {
    clearTimeout(timer);
    timer = null;
  };

  // Someone who opens or closes it themselves has taken over; never override.
  panel.addEventListener('toggle', cancel, { once: true });
  panel.addEventListener('pointerenter', cancel);
  panel.addEventListener('focusin', cancel);

  timer = setTimeout(() => {
    if (panel.matches(':hover') || panel.contains(document.activeElement)) return;
    panel.open = false;
  }, delay);
}

function scan(root = document) {
  root.querySelectorAll?.('[data-bb-autoclose]').forEach(arm);
}

scan();

// The drawer's markup arrives after this file does, and again after every cart
// update, so watch for it rather than assuming it is already there.
new MutationObserver((records) => {
  for (const record of records) {
    for (const node of record.addedNodes) {
      if (node.nodeType !== 1) continue;
      if (node.matches?.('[data-bb-autoclose]')) arm(node);
      scan(node);
    }
  }
}).observe(document.documentElement, { childList: true, subtree: true });
